module.exports = _.isBoolean;


//////////////////
// WEBPACK FOOTER
// external "_.isBoolean"
// module id = 574
// module chunks = business-manager/video-library-page full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings